import React from "react";
import "./counter.scss"

interface ICounter {
    count: number
    setCount: React.Dispatch<React.SetStateAction<number>>
    setActivate: React.Dispatch<React.SetStateAction<string>>
}

const Counter = ({count, setCount, setActivate}: ICounter) => {
    return (
        <div className="Counter">
            <div className="Counter-Action-Button" onClick={() => {
                setCount(++count);
                console.log(count)
            }}>+
            </div>
            <div className="Counter-Count">{count}</div>
            <div className="Counter-Action-Button" onClick={() => {
                if (count === 1) {
                    setActivate("none");
                    setCount(0)
                } else {
                    setCount(--count);
                    console.log(count)
                }
            }}>-
            </div>
        </div>
    );
}

export default Counter;